module.exports = __webpack_public_path__ + "img/add.d9ea45d9.svg";